/**
    The purpose of this method is to find all
    the entities that has been deleted.

    This is done by comparing oldEntities with the
    current entities, and compare the ids.

    @returns Array - An array with the id's of the deleted entities
*/

export default (curEntities, oldEntities = []) => {
    if (!curEntities || !oldEntities) {
        return [];
    }

    const deleted = []; // Array with the id's of the deleted entities

    oldEntities.forEach(entity => {
        const id = entity.id;
        const index = curEntities.findIndex(e => e.id === id);
        if (index === -1) {
            deleted.push(id);
        }
    });
    return deleted;
};
